import React, { Component } from 'react';
import { connect } from 'react-redux'

import Avatar from 'material-ui/Avatar';
import Chip from 'material-ui/Chip';


import AttachmentCard from './Attachments/AttachmentCard'
import DoneIcon from './icons/DoneIcon'

import dataActions from 'actions/dataActions'

import { doc, makeRefSelector } from '../selectors/common'
import { notificationAvatarTo } from '../selectors/attachments'

let select = (state, props) => ({
	notification: doc(state, props.id)
  , manager: makeRefSelector("to")(state, props.id)
  , managerAvatar: notificationAvatarTo(state, props.id)
})

export class NotificationChip extends Component{
	render(){
		let { props } = this
		return(
			<Chip
				labelStyle={{
					padding: "0"
				  , lineHeight: "normal"
				  , display: "flex"
				  , border: "1px solid rgba(0,0,0,0.2)"
				  , borderRadius: "16px"
				}}
				style={{
					float: "left"
				  , marginRight: "15px"
				  , marginBottom: "15px"
				  , zIndex: "0"
				}}
			>

						{(props.manager && props.managerAvatar)?
							<AttachmentCard attachmentID={props.managerAvatar._id} avatar={true} />
							:
							<img
								src={'/' + process.env.REACT_APP_NAME + "/static/img/res/avatar.png"}
								style={{
									width: '32px'
								  , height:'32px'
								  , display: 'inline-block'
								}}
							/>}
				<span
					style={{
						fontWeight: (!props.notification.read)? "bold" : "normal"
					  , margin: "0 15px"
					  , marginTop: "7px"
					}}
				>
					{props.manager.name}
				</span>
				<span
					style={{
						color: (props.notification.done)?"#FFF":"grey"
					  , background: (props.notification.done)?"#35ba9a":"rgba(255,255,255,0.6)"
					  , borderRadius: "100%"
					  , width: "32px"
					  , height: "32px"
					}}
				>
					<DoneIcon
						action={() => props.DOC_UPDATE({_id: props.id, done:(props.notification.done)? false: true})}
						style={{
							marginTop: "3px"
						  , marginLeft: "6px"
						}}
					/>
				</span>
			</Chip>
		)
	}
}

export default connect(select, dataActions)(NotificationChip)



// WEBPACK FOOTER //
// ./src/components/NotificationChip.js